import React from 'react';
import ToolbarList from '@configuratorware/configurator-frontendgui/App/Shared/Components/ToolbarList';
import customClassName from '@configuratorware/configurator-frontendgui/App/Utils/customClassName';
import Toolbar from '@material-ui/core/Toolbar';
import clsx from 'clsx';
import AppBar from '@material-ui/core/AppBar';
import { makeStyles } from '@material-ui/core/styles';
import StageTabs from './StageTabs';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import { MATERIAL } from '../../Constants/Steps';
import PDFDownload from './PDFDownload';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      flexGrow: 1,
    },
    grow: {
      flexGrow: 1,
    },
    headerRoot: {
      overflow: 'hidden',
    },
    toolbarHeaderWrapper: {
      minHeight: 60,
      padding: '0 10px 0 20px',
      [theme.breakpoints.down('xs')]: {
        padding: '0 0 0 20px',
      },
    },
    itemIdentifier: {
      whiteSpace: 'nowrap',
      fontSize: 15,
      lineHeight: '30px',
      flex: 1,
      textAlign: 'center',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'left',
      },
      [theme.breakpoints.down('xs')]: {
        maxWidth: 'calc(100vw - 60px)',
      },
    },
    itemIdentifierContainer: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'flex',
      flexDirection: 'row',
      flexGrow: 1,
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        paddingBottom: 11,
      },
    },
    stages: {
      flexBasis: '100%',
      minHeight: 48,
      [theme.breakpoints.up('md')]: {
        flexBasis: 'auto',
      },
    },
    leftContainer: {
      flex: 1,
      display: 'flex',
      flexWrap: 'wrap',
      maxWidth: '100%', // subtracting with header action icons widths
      [theme.breakpoints.down('xs')]: {
        maxWidth: 'calc(100% - 48px)',
      },
    },
    rightContainer: {
      alignSelf: 'flex-start',
      minHeight: 48,
      display: 'flex',
      alignItems: 'center',
      marginRight: theme.spacing(1),
      [theme.breakpoints.up('sm')]: {
        alignSelf: 'flex-end',
      },
      [theme.breakpoints.up('xs')]: {
        minHeight: 60,
      },
    },
    title: {
      fontWeight: 'bold',
      fontStyle: 'italic',
    },
  }),
  {
    name: 'Header',
  }
);

export const Header = () => {
  const classes = useStyles();
  const { selectedStage } = useSelector((state) => get(state, 'configurator', {}));

  return (
    <div className={classes.root}>
      <AppBar
        position="static"
        color="default"
        className={clsx(classes.headerRoot, customClassName('header'))}
      >
        <Toolbar classes={{ regular: classes.toolbarHeaderWrapper }}>
          <div className={classes.leftContainer}>
            <StageTabs className={classes.stages} />
          </div>
          {selectedStage === MATERIAL && (
            <div className={classes.rightContainer}>
              <PDFDownload />
            </div>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Header;
